/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ai-summary-label': 'Resumir',
  'copy-content-link-label': 'Copiar enlace',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Comienza a escribir para buscar una etiqueta',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Todos',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrar búsqueda por producto',
  'dynamic-cards-search-page.app-filter-sidebar.group-appify': 'Filtrar búsqueda por aplicación',
  'dynamic-cards-search-page.atlas.for': 'para',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Calendario',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Unirse a la reunión',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Enlace de la reunión',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Unirse a la reunión',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Eventos pasados',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Evento recurrente',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Periódicamente',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Próximos eventos',
  'dynamic-cards-search-page.compass.owner-name': 'Propiedad de {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Nivel {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Encontrar contenido',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Seleccionado',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Sugerido',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Seleccionada',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Sugerida',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Buscar personas',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Seleccionado',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Buscar etiquetas',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Buscar espacios',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Conecta tu cuenta para ver los resultados que faltan',
  'dynamic-cards-search-page.connect_third_party_product_title': '¡Tu administrador ha añadido {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '¡{product} ya está disponible!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end':
    'La fecha de inicio debe ser anterior a la fecha de finalización',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today':
    'La fecha de inicio no puede ser una fecha futura',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today':
    'La fecha de finalización no puede ser una fecha futura',
  'dynamic-cards-search-page.date.filter.last.month': 'Últimos 30 días',
  'dynamic-cards-search-page.date.filter.last.week': 'Últimos 7 días',
  'dynamic-cards-search-page.date.filter.last.year': 'Último año',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Palabra',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Generar respuesta',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Recientes',
  'dynamic-cards-search-page.error_primary': 'Estamos teniendo problemas para hacer la búsqueda',
  'dynamic-cards-search-page.error_secondary':
    'Puede que solo sea un contratiempo. Lo mejor es <btn>intentarlo de nuevo</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Personas externas #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Borrar filtro',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'En cualquier momento',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Últimos 30 días',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Últimos 7 días',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Último año',
  'dynamic-cards-search-page.filter.last.updated.today': 'Hoy',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Ayer',
  'dynamic-cards-search-page.filter.type.answer': 'Respuestas',
  'dynamic-cards-search-page.filter.type.attachment': 'Archivos adjuntos',
  'dynamic-cards-search-page.filter.type.blogpost': 'Entradas de blog',
  'dynamic-cards-search-page.filter.type.branch': 'Ramas',
  'dynamic-cards-search-page.filter.type.calendar': 'Calendarios',
  'dynamic-cards-search-page.filter.type.comment': 'Comentarios',
  'dynamic-cards-search-page.filter.type.commit': 'Confirmaciones',
  'dynamic-cards-search-page.filter.type.component': 'Componentes',
  'dynamic-cards-search-page.filter.type.conversation': 'Conversaciones',
  'dynamic-cards-search-page.filter.type.database': 'Bases de datos',
  'dynamic-cards-search-page.filter.type.design': 'Diseños',
  'dynamic-cards-search-page.filter.type.documents': 'Documentos',
  'dynamic-cards-search-page.filter.type.embed': 'Enlaces inteligentes',
  'dynamic-cards-search-page.filter.type.folder': 'Carpetas',
  'dynamic-cards-search-page.filter.type.message': 'Mensajes',
  'dynamic-cards-search-page.filter.type.page': 'Páginas',
  'dynamic-cards-search-page.filter.type.placeholder': 'Buscar tipo',
  'dynamic-cards-search-page.filter.type.presentation': 'Presentaciones',
  'dynamic-cards-search-page.filter.type.pull-request': 'Solicitudes de extracción',
  'dynamic-cards-search-page.filter.type.question': 'Preguntas',
  'dynamic-cards-search-page.filter.type.repository': 'Repositorios',
  'dynamic-cards-search-page.filter.type.space': 'Espacios',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Calendarios de espacio',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Hojas de cálculo',
  'dynamic-cards-search-page.filter.type.video': 'Vídeos',
  'dynamic-cards-search-page.filter.type.web-page': 'Páginas web',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Pizarras',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Borrar todo',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filtro',
  'dynamic-cards-search-page.filters.names.content': 'Contenido de',
  'dynamic-cards-search-page.filters.names.contributor': 'Colaborador',
  'dynamic-cards-search-page.filters.names.labels': 'Etiqueta',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Título coincidente',
  'dynamic-cards-search-page.github-branch-result.label': 'Rama',
  'dynamic-cards-search-page.github-commit-result.label': 'Confirmación',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Solicitud de incorporación de cambios',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Buscar cualquier cosa',
  'dynamic-cards-search-page.jira.filter.assignee.selected': 'Seleccionados',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Buscar proyectos',
  'dynamic-cards-search-page.landing_primary': 'Primeros pasos con los filtros para tarjetas dinámicas',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Documentos',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Diapositivas',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Hojas',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'No se han encontrado resultados de búsqueda',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Parece que tienes algún filtro aplicado. Podrías intentar limpiarlos.',
  'dynamic-cards-search-page.nouns.tag': 'Etiqueta',
  'dynamic-cards-search-page.nouns.tags': 'Etiquetas',
  'dynamic-cards-search-page.number_of_results':
    'Se muestran {numberOfResults,number} de {totalCount,number} resultados',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Error en la autorización de {product}.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Autorización correcta de {product}.',
  'dynamic-cards-search-page.oauth-message-connect': 'Conectar',
  'dynamic-cards-search-page.products.custom-website': 'Página web',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Ordenados por creación (más reciente)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Creación (más reciente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Actualización (más reciente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected':
    'Ordenados por actualización (más reciente)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Cambiar el orden de la lista',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Siguiente',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtra por producto para obtener resultados de búsqueda más relevantes.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description-appify':
    'Filtra por aplicación para obtener resultados de búsqueda más relevantes.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Buscar en todos los espacios de trabajo de tu empresa',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Dependiendo del producto por el que estés filtrando, estas opciones cambian para ayudarte a obtener resultados específicos.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description-appify':
    'Dependiendo de la aplicación por la que estés filtrando, estas opciones cambian para ayudarte a obtener resultados específicos.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Encontrar exactamente lo que estés buscando',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Archivo adjunto',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Adjuntado el {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Audio',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Imagen',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Última actualización: {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Canal privado',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Eliminar el icono de búsqueda reciente',
  'dynamic-cards-search-page.search-result.repository-label': 'Repositorio',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Mensaje grupal con usuarios externos} =2 {{name1} y {name2}} =3 {{name1}, {name2} y {name3}} =4 {{name1}, {name2}, {name3} y {overflowContributorCount} más} one {{name1}} other {{name1}, {name2}, {name3} y {overflowContributorCount} más}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'canal-desconocido',
  'dynamic-cards-search-page.search_result_type_answer': 'Respuesta',
  'dynamic-cards-search-page.search_result_type_card': 'Tarjeta',
  'dynamic-cards-search-page.search_result_type_component': 'Componente',
  'dynamic-cards-search-page.search_result_type_embed': 'Enlace inteligente',
  'dynamic-cards-search-page.search_result_type_folder': 'Carpeta',
  'dynamic-cards-search-page.search_result_type_presentation': 'Presentación',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Solicitud de extracción',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Documento de SharePoint',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Calendario de espacio',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Hoja de cálculo',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'No reconocido',
  'dynamic-cards-search-page.search_result_type_work_item': 'Actividad',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    '¡Tu administrador ha añadido <strong>{product}!</strong>{br} Conecta tu cuenta para ver los resultados que faltan, incluidos los documentos a los que solo tú tienes acceso.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>¡{product} ya está disponible!</strong>{br} Conecta tu cuenta para ver los resultados que faltan, incluidos los documentos a los que solo tú tienes acceso.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autorizar',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Error en la autorización de {product}.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Autorización correcta de {product}.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrar por todas las aplicaciones',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrar por más aplicaciones',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Archivado',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'En riesgo',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Cancelado',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Completado',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Fuera del plazo',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'En el plazo',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'En pausa',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Pendiente',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} capítulo en este vídeo} other {{chapterCount,number} capítulos en este vídeo}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'icono de vídeo',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Miniatura del vídeo',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'la tiene asignada',
  'dynamic-cards-search-page.work-item-creator.created': 'la ha creado',
  'dynamic-cards-search-page.work-item-status.for': 'para',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Actividad',
  'initialsAvatar.label': 'Iniciales del avatar',
  'personAvatar.label': 'Avatar de persona',
  'search-page.results.private-result-label': 'Privado',
  'search-page.results.private-result-tooltip': 'Solo visible para ti',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} miembro} other {{memberCount,number} miembros}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Canal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Canal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} miembro} other {{count,number} miembros}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Fecha de última actividad: {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'canal-desconocido',
  'search-page.results.product-results.third-party.external-people-label': 'Personas externas',
  'search-page.results.product-results.third-party.external-person-label': 'Persona externa',
  'search-page.results.product-results.third-party.last-active': 'Fecha de última actividad: {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Mensaje',
  'search-page.results.product-results.third-party.no-contributors-label': 'Personas externas en #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} en una conversación privada',
  'search-page.results.product-results.third-party.thread-type-label': 'Hilo',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} en #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} y {remainingContributorsCount} más} other {{title} y {remainingContributorsCount} más}}',
  'search-page.results.restricted-result-label': 'Restringido',
  'search-page.results.restricted-result-tooltip': 'Solo visible para personas específicas',
  'search-page.show-more-breadcrumbs-button-label': 'Mostrar más del historial',
  'search-page.verified-icon-label': 'Verificado',
  'search-page.verified-icon-tooltip-message': 'Un propietario o un administrador ha verificado esta página.',
  'search-result.result.count':
    '{count, plural, one {Se muestra {count} resultado} other {Se muestran {count} resultados}}',
  'search-result.user-mention.external-person': 'Persona externa',
};
